import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import type { DisplayedSubjectQuote } from '../../../../../types';
import useDeleteQuoteModal from './useDeleteQuoteModal';

type Props = {
  quote: DisplayedSubjectQuote;
  subjectId: string;
  onClose: () => void;
};

export default function DeleteQuoteModal(props: Props) {
  const hook = useDeleteQuoteModal(props);
  const isSingleDocument = hook.documentsCount === 1;

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title="Supprimer le devis"
      closeLabel="Fermer"
      actions={hook.hasDocuments ? {
        primaryAction: {
          label: isSingleDocument ? 'Supprimer devis et document' : 'Supprimer devis et documents',
          color: 'error',
          onClick: hook.handleDeleteWithDocuments,
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Supprimer le devis seul',
          onClick: hook.handleDeleteQuoteOnly,
          disabled: hook.isPending,
        },
        tertiaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      } : {
        primaryAction: {
          label: 'Supprimer',
          color: 'error',
          onClick: hook.handleDeleteQuoteOnly,
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Typography variant="body1">
          Supprimer le devis de <strong>{hook.providerName}</strong>&nbsp;?
        </Typography>

        {hook.hasDocuments ? (
          <>
            <Typography variant="body1">
              {isSingleDocument
                ? `Un document est associé à ce devis : ${hook.documentNames[0] || 'Document'}.`
                : `${hook.documentsCount} documents sont associés à ce devis : ${hook.documentNames.join(', ')}.`}
            </Typography>
            <Typography variant="body2">
              {isSingleDocument
                ? 'Supprimez-le avec le devis, ou supprimez le devis seul pour le garder dans les documents du sous-sujet.'
                : 'Supprimez-les avec le devis, ou supprimez le devis seul pour les garder dans les documents du sous-sujet.'}
            </Typography>
          </>
        ) : (
          <Typography variant="body2">Cette action est irréversible.</Typography>
        )}
      </Stack>
    </Dialog>
  );
}
